import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'fetra',
} as IModuleProps;
